import { WarningAmberRounded } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';

interface Props {
  message: string;
}

/** Centered notice shown in place of a dashboard graph when there is no data. */
const ChartEmptyMessage = ({ message }: Props) => (
  <Stack
    height='100%'
    direction='row'
    justifyContent='center'
    alignItems='center'
    spacing={1}
  >
    <WarningAmberRounded color='warning' />
    <Typography sx={{ fontSize: 15, color: 'text.secondary' }}>
      {message}
    </Typography>
  </Stack>
);

export default ChartEmptyMessage;
